function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#def_svg__clip0)",
  fill: "#0785FE"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.938 13.594V1.405c0-.259.21-.469.468-.469h7.032v1.875c0 .518.42.938.937.938h1.875v1.406h.938V3.281a.469.469 0 00-.136-.333L9.239.136A.469.469 0 008.906 0h-7.5C.63 0 0 .63 0 1.406v12.188C0 14.37.63 15 1.406 15h4.688v-.938H1.406a.469.469 0 01-.468-.468z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.781 6.563a4.219 4.219 0 100 8.437 4.219 4.219 0 000-8.438zm0 7.5a3.281 3.281 0 110-6.563 3.281 3.281 0 010 6.563z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.313 11.527l-1.074-1.074-.66.661 1.405 1.406a.469.469 0 00.661 0l2.344-2.343-.66-.661-2.017 2.01z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "def_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h15v15H0z"
})));

function SvgDef(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgDef;